<ng-template #picture>
  <div
    class="d-inline position-relative"
    [class.img-border]="enableImageBorder"
    [class.pending]="userStatus === OnlineStatusEnum.PENDING"
    [class.img-border-animated]="showAnimatedImageBorder"
    (animationend)="onBorderAnimationEnd($event)"
    #avatarContainer
  >
    <ng-container *ngIf="profileImage">
      <img
        [src]="profileImage"
        class="profile-icon"
        [width]="width || 16"
        [height]="width || 16"
        [style]="{
          'min-width': width + 'px',
          'min-height': width + 'px',
          transform: 'scale(' + imgScale + ')'
        }"
        alt="{{ 'profile icon' | translate }}"
        data-name="user-profile-image"
      />
      <div *ngIf="opaqueOverlay" class="profile-image-overlay"></div>
    </ng-container>
    <svg-icon
      *ngIf="!isUser && !isInstitution"
      class="profile-icon"
      [appTooltip]="'This user does not exist anymore' | translate"
      alt=" user-profile-image"
      [width]="width || 16"
      [height]="width || 16"
      [icon]="'user'"
      [style]="{ 'min-width': width + 'px', 'min-height': width + 'px' }"
    >
    </svg-icon>
    <span
      *ngIf="isUser && !profileImage"
      class="profile-icon truncate"
      [ngClass]="imgBorder ? 'white-border' : ''"
      [style.width]="(width || 16) + 'px'"
      [style.height]="(width || 16) + 'px'"
      [style.font-size]="fontSize + 'px'"
      [style.font-weight]="fontWeight"
      >{{ userName ? (userName | shortName) : (userEmail! | shortName) }}</span
    >
    <img
      class="profile-icon-institution"
      *ngIf="isInstitution && !isUser && institutionLogo"
      [src]="institutionLogo"
      [appTooltip]="institutionName"
      [width]="width || 16"
      [style]="{ 'min-width': width + 'px', 'min-height': width + 'px' }"
      alt="{{ 'institution icon' | translate }}"
    />
    <svg-icon
      class="profile-icon-institution"
      *ngIf="isInstitution && !isUser && !institutionLogo"
      [icon]="'user'"
      [width]="width || 16"
    ></svg-icon>
    <span *ngIf="isUser && showStatus" class="status"></span>
    <div
      *ngIf="
        isUser &&
        userStatus &&
        ![OnlineStatusEnum.OFFLINE, OnlineStatusEnum.PENDING].includes(userStatus)
      "
      [ngClass]="{ status: !userStatus, status_v2: !!userStatus }"
      [class.online]="userStatus === OnlineStatusEnum.ONLINE"
      [class.in_call]="userStatus === OnlineStatusEnum.IN_CALL"
    >
      <mat-icon *ngIf="userStatus === OnlineStatusEnum.IN_CALL" class="material-icons call-icon"
        >call</mat-icon
      >
    </div>
    <div *ngIf="showBadge && badgeIconConfig" class="avatar-badge">
      <app-pencil-icon
        [name]="badgeIconConfig.name"
        [type]="badgeIconConfig.type"
        [outlined]="badgeIconConfig.outlined ?? false"
      ></app-pencil-icon>
    </div>
  </div>
</ng-template>

<div
  id="btn-home-avatar-menu"
  class="profile-container"
  data-name="spaces-manager-user-avatar-menu"
  [style.display]="parentDisplay ?? 'flex'"
  [class.in-call]="userStatus === OnlineStatusEnum.IN_CALL"
  [appTooltipDisabled]="userStatus !== OnlineStatusEnum.PENDING"
  [appTooltip]="'User is currently moving to this room' | translate"
  [appTooltipArrow]="'top'"
  [appTooltipPlacement]="'bottom-center'"
>
  <ng-template *ngTemplateOutlet="picture"></ng-template>
  <div class="d-inline-flex flex-column display-name" *ngIf="showName">
    <div
      class="profile-username"
      [style.font-weight]="fontWeight"
      [style.font-size]="fontSize + 'px'"
      [style.color]="fontColor"
    >
      <span
        *ngIf="highlightedText"
        class="name-text truncate"
        [innerHTML]="
          (userName | highlighter: highlightedText) || (userEmail | highlighter: highlightedText)
        "
      ></span>
      <span *ngIf="!highlightedText" class="name-text truncate">{{ userName || userEmail }}</span>
      <span *ngIf="showHostTag && userRole === UserRoleEnum.HOST" class="name-suffix">
        {{ ' (Host)' | translate }}
      </span>
      <span [hidden]="!showYouWord" class="name-suffix">{{ ' (You)' | translate }}</span>
    </div>
    <div *ngIf="showSubtext && subText" class="profile-subtext truncate">
      {{ subText }}
    </div>
  </div>
</div>
